import React from 'react';
import { 
  Grid2 as Grid, Typography, ListItem, ListItemText
} from '@mui/material';
import PropTypes from 'prop-types';

const StepsForgotPass = ({ pasos }) => {
  return (
    <Grid className="steps" size={{ xs:12, lg:6 }}>
      <img src="/logo-os 24.svg" alt="OneService" />
      <Typography variant="h5" component="h5">Selección de recuperación</Typography>
      <Grid className="list-steps" size={12}>
        <ListItem className="step-active" alignItems="flex-start">
          <ListItemText primary="Selección de recuperación" />
        </ListItem>
        <ListItem className={pasos > 1 ? 'step-active': ''} alignItems="flex-start">
          <ListItemText primary="Autentificación" />
        </ListItem>
        <ListItem className={pasos > 2 ? 'step-active': ''}  alignItems="flex-start">
          <ListItemText primary="Código" />
        </ListItem>
        <ListItem className={pasos > 3 ? 'step-active': ''} alignItems="flex-start">
          <ListItemText primary="Nueva contraseña" />
        </ListItem>
      </Grid>
    </Grid>
  );
}

StepsForgotPass.propTypes = {
  pasos: PropTypes.number.isRequired
}

export default StepsForgotPass